import { useMutation, useQueryClient } from '@tanstack/react-query';
import { submitOnboardingProfile } from '@/api/auth';
import { useAuthStore } from '@/store/authStore';
import { queryKeys } from '@/api/queryKeys';
import type { ProfileUpdateRequest } from '@/types/auth';

/** Submit (or skip) the post-signup profiling step and flip show-once locally. */
export function useSubmitProfile() {
  const qc = useQueryClient();
  const user = useAuthStore((s) => s.user);
  const setUser = useAuthStore((s) => s.setUser);

  return useMutation({
    mutationFn: (data: ProfileUpdateRequest) => submitOnboardingProfile(data),
    onSuccess: (res) => {
      if (user) {
        setUser({
          ...user,
          organization: res.organization_name
            ? { ...user.organization, name: res.organization_name }
            : user.organization,
          profile_completed_at: res.profile_completed_at ?? new Date().toISOString(),
        });
      }
      qc.invalidateQueries({ queryKey: queryKeys.auth.me });
    },
  });
}
